/* Common Imports */

import React from "react";

/* Redux & Type Imports */

import { ObjectId } from "bson";
import { NextRouter } from "next/router";
import StateInterface from "../../../redux-magic/state-interface";

/* Component Imports */

import BroadcastCard from "./PropertyCardBroadcast/PropertyCardBroadcast";

/* Styled Components */

const PropertyCardBroadcast = ({
	broadcast_id,
	dispatch,
	session,
	router,
	profile_context,
	isEditor,
	source,
}: {
	broadcast_id: ObjectId | string;
	dispatch: Function;
	session: StateInterface["redux_session"];
	router: NextRouter;
	profile_context: any;
	isEditor?: boolean | undefined;
	source?: string;
}) => {
	const [broadcastData, setBroadcastData] = React.useState<any>({});

	const [broadcastDataloading, setBroadcastDataLoading] = React.useState(true);

	React.useEffect(() => {
		if (broadcast_id) {
			/* Fetching broadcast data */

			fetch(`${process.env.PRODUCTION_API_URL}broadcast/fetch-broadcast-details?resize=""`, {
				method: "POST",
				cache: "no-store",
				body: JSON.stringify({
					broadcast_id: broadcast_id,
					is_business_profile: profile_context.is_business_profile,
					user_id: profile_context.user_id,
					business_profile_id: profile_context.business_profile_id,
					sessionId: session ? (session.session_id ? session.session_id : "") : "",
				}),
			})
				.then((res) => res.json())
				.then((data) => {
					setBroadcastData(data);
					setBroadcastDataLoading(false);
				});
		}

		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [broadcast_id]);

	// if (broadcastDataloading) {
	// 	return (
	// 		<PropertyLoadingCardDashboardEditorView
	// 			source={source}
	// 			isEditor={isEditor}
	// 		/>
	// 	);
	// }

	return (
		<React.Fragment>
			<BroadcastCard
				_id={broadcastData.broadcast_data ? broadcastData.broadcast_data._id : ""}
				profile_context={profile_context}
				session={session ? session : null}
				dispatch={dispatch}
				router={router}
				loading={broadcastDataloading}
				property_id={broadcastData.broadcast_data ? broadcastData.broadcast_data.property_id._id : ""}
				property_slug={broadcastData.broadcast_data ? broadcastData.broadcast_data.property_id.slug : ""}
				property_transaction_type={
					broadcastData.broadcast_data?.property_id.transaction_type
						? broadcastData.broadcast_data.property_id.transaction_type
						: ""
				}
				property_type={broadcastData.broadcast_data?.property_id.property_type}
				property_title={broadcastData.broadcast_data?.property_id.title}
				property_images={broadcastData.broadcast_data?.property_id.images}
				property_location={
					broadcastData.broadcast_data?.property_id.location
						? broadcastData.broadcast_data?.property_id.location.title
						: ""
				}
				property_price={broadcastData.broadcast_data?.property_id.price}
				property_bhk={broadcastData.broadcast_data?.property_id.bhk}
				property_area={broadcastData.broadcast_data?.property_id.area}
				property_no_of_seats={broadcastData.broadcast_data?.property_id.no_of_seats}
				created_by={broadcastData ? broadcastData.broadcast_data?.created_by : null}
				created_at={broadcastData.broadcast_data ? broadcastData.broadcast_data?.updated_at : ""}
				source={source}
				isEditor={isEditor}
				commission={broadcastData.broadcast_data?.commission_offered}
				notes={broadcastData.broadcast_data?.notes}
				is_expired={broadcastData.broadcast_data?.is_expired}
				invite_status={broadcastData.broadcast_recipient_data?.recipient.invite_status}
				is_read={broadcastData.broadcast_recipient_data?.recipient.is_read}
				chat_id={broadcastData.broadcast_data?.chat_id ? broadcastData.broadcast_data?.chat_id : ""}
			/>
		</React.Fragment>
	);
};

export default PropertyCardBroadcast;
